<template>
  <div>
    <Modal
      v-model="storeInfoReviewModalVisible"
      class-name="storeInfoReviewStyle"
      width="1000"
      :transfer="false"
      :mask-closable="false"
      :title="modalTitle"
      @on-visible-change="modalVisibleChange">
      <Form
        :model="storeInfoForm"
        :disabled="operationType === 'look'"
        ref="storeInfoForm"
        :rules="ruleValidate"
        :label-width="160"
        @submit.native.prevent>
        <Row>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002774')" prop="shopName">
              <span v-if="viewStatus" class="labelText">{{ storeInfoForm.shopName || '-' }}</span>
              <Input v-else v-model.trim="storeInfoForm.shopName" :placeholder="$t('key1002775')" clearable
                style="width: 350px;"></Input>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002776')" prop="shopLogoPath" class="required_style_label">
              <Upload
                class="upload_styles"
                ref="upload"
                type="drag"
                name="files"
                v-if="!viewStatus"
                :headers="headObj"
                :action="fileApi"
                :data="uploadData"
                :show-upload-list="false"
                :on-success="uploadSuccess"
                :format="['jpg', 'jpeg', 'png']"
                :max-size="20480"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize">
                <div class="img_style" v-if="storeInfoForm.shopLogoPath">
                  <img :src="setImgPath(storeInfoForm.shopLogoPath)" alt=""/>
                </div>
                <div class="upload_icon_box" v-else>
                  <Icon type="ios-cloud-upload" size="45" style="color: #3399ff"></Icon>
                  <p>{{ $t('key1000465') }}</p>
                </div>
              </Upload>
              <img v-else class="viewImgStyles" v-viewer="viewerOptions"
                :src="setImgPath(storeInfoForm.shopLogoPath)" alt=""/>
              <p class="font-size-12">{{ $t('key1002798') }}</p>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002777')">
              <span class="labelText">{{ storeInfoForm.managementModel || '-' }}</span>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002778')">
              <span class="labelText">{{ storeInfoForm.plannedBusinessCategory || '-' }}</span>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002779')">
              <span class="labelText">{{ storeInfoForm.shelvesProductsNumber || '-' }}</span>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002780')">
              <span class="labelText">{{ storeInfoForm.productReleaseNumber || '-' }}</span>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002782')">
              <span class="labelText">{{ storeInfoForm.businessAddress || '-' }}</span>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001168')">
              <span class="labelText">{{ storeInfoForm.address || '-' }}</span>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <template v-if="operationType === 'audit'">
          <Button type="error" ghost @click="rejectBtn"
            v-if="updateSupplierStoreAuditStatus !== 0">{{ $t('key1002713') }}</Button>
          <Button type="primary" @click="approvedBtn">{{ $t('key1000986') }}</Button>
        </template>
        <template v-if="operationType === 'edit'">
          <Button @click="storeInfoReviewModalVisible = false">{{ $t('key1000112') }}</Button>
          <Button type="primary" @click="submitBtn">{{ $t('key1000555') }}</Button>
        </template>
        <template v-if="operationType === 'look'">
          <Button type="primary" @click="storeInfoReviewModalVisible = false">{{ $t('key1000248') }}</Button>
        </template>
      </template>
    </Modal>
    <!--驳回弹窗-->
    <rejectApplicationModal
      ref="rejectApplication"
      :toExamineStatus="4"
      :ymsMerchantId="ymsMerchantId"
      @resetDetails="resetDetails"
      @rejectApplicationUpdateData="rejectApplicationUpdateData">
    </rejectApplicationModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import rejectApplicationModal from "@/views/yms/components/supplierManagement/rejectApplicationModal.vue";
import {getDataSetBatchList, getEnumList, getEnumName} from "@/utils/common";

export default {
  name: 'storeInfoReviewModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      storeInfoReviewModalVisible: false,
      modalTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002826'),
      operationType: 'look', // 操作类型：audit(审核)、edit(编辑)、look(查看)
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-core-service&action="uploadimage"',
      uploadData: {},
      ymsMerchantId: null,
      ymsMerchantStoreId: null,
      storeInfoForm: {
        shopName: '',
        shopLogoPath: null,
        managementModel: null,
        plannedBusinessCategory: '',
        shelvesProductsNumber: null,
        productReleaseNumber: null,
        businessAddress: '',
        address: '',
      },
      ruleValidate: {
        shopName: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002730'), trigger: 'blur'}],
        shopLogoPath: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!this.storeInfoForm.shopLogoPath) {
              callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002827')));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
      },
      detailsData: {},
      enumData: [],
      // 经营模式
      managementModelList: [],
      // 发布类型
      releaseTypeList: [],
      // 计划经营类目
      plannedBusinessCategoryList: [],
      scaleList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002735')},
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002736')},
        {value: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002737')},
        {value: 4, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002738')},
        {value: 5, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002739')}
      ],
      groundingList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002740')},
        {value: 2, name: '10~30'},
        {value: 3, name: '30~50'},
        {value: 4, name: '50~100'},
        {value: 5, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002741')}
      ],
      businessAddressData: [],
      updateSupplierStoreAuditStatus: null,
    };
  },
  computed: {
    viewStatus() {
      return this.operationType === 'look';
    },
  },
  methods: {
    // 初始化店铺信息审核弹窗数据
    async initStoreInfoReviewData(type, data, value) {
      let v = this;
      v.operationType = type;
      v.ymsMerchantId = null;
      v.ymsMerchantStoreId = null;
      if (!value) {
        v.detailsData = {};
      }

      // 设置标题
      let titleMap = {
        audit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002828'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002829'),
        look: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002826'),
      };
      v.modalTitle = titleMap[type] || aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002826');

      if (data) {
        v.detailsData = JSON.parse(JSON.stringify(data));
        v.ymsMerchantId = data.ymsMerchantId || null;
      }

      // 加载枚举数据
      let enumKeyList = [
        'YmsMerchantStoreManagementModelCoreEnum',
        'YmsMerchantStoreProductReleaseRateCoreEnum',
        'YmsMerchantStoreAttributeAttributeValueCoreEnum'
      ];
      v.enumData = await getDataSetBatchList(enumKeyList);

      // 加载省市区数据
      await v.getProvinceBasicData('CN').then((list) => {
        if (list.length > 0) {
          v.businessAddressData = list;
        }
      });

      // 获取供应商详情
      v.getSupplierDetails(type);
    },
    // 获取供应商详情数据
    getSupplierDetails(type) {
      let v = this;
      let url = '';
      if (type === 'audit') {
        url = api.get_ymsSupplierMerchant_audit;
      } else {
        url = api.get_ymsSupplierMerchant;
      }
      v.axios.get(url + v.ymsMerchantId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.updateSupplierStoreAuditStatus = data.updateSupplierStoreAuditStatus?.updateSupplierStoreAuditStatus;
            let ymsMerchantStores = data.ymsMerchantStores || [];
            if (ymsMerchantStores.length > 0) {
              let storesObj = ymsMerchantStores[0];
              v.ymsMerchantStoreId = storesObj.ymsMerchantStoreId;
              v.storeInfoForm.shopName = storesObj.name || '';
              v.storeInfoForm.shopLogoPath = storesObj.shopLogoPath || null;

              // 处理经营模式
              let managementModelList = getEnumList(v.enumData, 'YmsMerchantStoreManagementModelCoreEnum', 'number');
              v.managementModelList = managementModelList;
              managementModelList.forEach((ele) => {
                if (ele.value === storesObj.managementModel) {
                  v.storeInfoForm.managementModel = ele.name;
                }
              });

              // 处理预计上架商品数
              v.groundingList.forEach((ele) => {
                if (ele.value === storesObj.shelvesProductsNumber) {
                  v.storeInfoForm.shelvesProductsNumber = ele.name;
                }
              });

              // 处理商品发布频率
              let releaseTypeList = getEnumList(v.enumData, 'YmsMerchantStoreProductReleaseRateCoreEnum', 'number');
              v.releaseTypeList = releaseTypeList;
              releaseTypeList.forEach((ele) => {
                if (ele.value === storesObj.productReleaseRate) {
                  let rateName = ele.name;
                  let releaseName = rateName + (storesObj.productReleaseNumber || '') + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002749');
                  v.storeInfoForm.productReleaseNumber = rateName !== aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002750') ? releaseName : rateName;
                }
              });

              // 处理计划经营类目
              let plannedBusinessCategoryList = getEnumList(v.enumData, 'YmsMerchantStoreAttributeAttributeValueCoreEnum', 'number');
              v.plannedBusinessCategoryList = plannedBusinessCategoryList;
              let ymsMerchantStoreAttributes = storesObj.ymsMerchantStoreAttributes || [];
              if (ymsMerchantStoreAttributes.length > 0) {
                let categoryList = [];
                ymsMerchantStoreAttributes.forEach((item) => {
                  plannedBusinessCategoryList.forEach((ele) => {
                    if (ele.value === item.attributeValue) {
                      categoryList.push(ele.name);
                    }
                  });
                });
                v.storeInfoForm.plannedBusinessCategory = categoryList.join('、');
              }

              // 处理地址信息
              let ymsMerchantStoreAddresses = storesObj.ymsMerchantStoreAddresses || [];
              v.storeInfoForm.businessAddress = '';
              v.storeInfoForm.address = '';
              if (ymsMerchantStoreAddresses.length > 0) {
                let addressesInfo = ymsMerchantStoreAddresses[0];
                v.storeInfoForm.businessAddress = v.handleAddressName(addressesInfo, v.businessAddressData);
                v.storeInfoForm.address = storesObj.address ? storesObj.address : addressesInfo.street;
              }
            }
            v.storeInfoReviewModalVisible = true;
            v.$forceUpdate();
          }
        }
      });
    },
    // 店铺Logo上传成功
    uploadSuccess(response, file, fileList) {
      let v = this;
      if (response.code === 0) {
        v.storeInfoForm.shopLogoPath = response.datas[0];
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002830'));
      } else {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002831'));
      }
    },
    // 校验文件格式
    handleFormatError(file) {
      this.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002532')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002533')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002726')}`,
        duration: 5
      });
    },
    // 限制上传的文件不能超过20M
    handleMaxSize(file) {
      this.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000030')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000031')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000032')}`,
        duration: 5
      });
    },
    // 编辑模式下的保存按钮
    submitBtn() {
      let v = this;
      v.$refs['storeInfoForm'].validate((valid) => {
        if (valid) {
          let query = {
            updateSupplierRegisterStoreInfo: {
              name: v.storeInfoForm.shopName,
              shopLogoPath: v.storeInfoForm.shopLogoPath,
              ymsMerchantStoreId: v.ymsMerchantStoreId || null,
            },
            ymsMerchantId: v.ymsMerchantId
          };
          v.axios.post(api.post_ymsSupplierMerchant_updateSupplierRegisterInfo, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113'));
              v.storeInfoReviewModalVisible = false;
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 审核通过
    approvedBtn() {
      let v = this;
      v.$refs['storeInfoForm'].validate((valid) => {
        if (valid) {
          let params = {
            auditRemarks: null,
            ymsMerchantId: v.ymsMerchantId,
            updateSupplierStoreAuditStatus: 2, // 0审核不通过、1待审核、2审核通过
            updateSupplierRegisterStoreInfo: {
              name: v.storeInfoForm.shopName,
              shopLogoPath: v.storeInfoForm.shopLogoPath,
              ymsMerchantStoreId: v.ymsMerchantStoreId || null,
            }
          };
          v.axios.post(api.post_ymsSupplierMerchant_updateSupplierRegisterInfoAudit, params,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002694'));
              v.storeInfoReviewModalVisible = false;
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 驳回按钮
    rejectBtn() {
      this.storeInfoReviewModalVisible = false;
      this.$refs['rejectApplication'].rejectApplicationModal = true;
    },
    // 重新获取详情数据
    resetDetails(val) {
      if (!val) {
        this.initStoreInfoReviewData('audit', this.detailsData, true);
      }
    },
    // 驳回成功之后
    rejectApplicationUpdateData() {
      this.$refs['rejectApplication'].rejectApplicationTalg = false;
      this.$refs['rejectApplication'].rejectApplicationModal = false;
      this.storeInfoReviewModalVisible = false;
      this.$emit('updateData', true);
    },
    // 监听弹窗关闭
    modalVisibleChange(value) {
      if (!value) {
        this.$nextTick(() => {
          if (this.$refs['storeInfoForm']) {
            this.$refs['storeInfoForm'].resetFields();
          }
        });
        this.storeInfoForm = {
          shopName: '',
          shopLogoPath: null,
          managementModel: null,
          plannedBusinessCategory: '',
          shelvesProductsNumber: null,
          productReleaseNumber: null,
          businessAddress: '',
          address: '',
          settlementCurrency: '',
          originalCountryCode: '',
        };
        this.supplierDetails = {};
        this.ymsMerchantStoreId = null;
        this.enumData = [];
        this.businessAddressData = [];
        this.updateSupplierStoreAuditStatus = null;
      }
    },
  },
  components: {
    rejectApplicationModal
  }
};
</script>

<style lang="less" scoped>
/deep/ .storeInfoReviewStyle {

  .title_box {
    font-size: 15px;
    font-weight: bold;
    color: #000;
  }

  .ivu-modal-body {
    max-height: 650px;
    overflow-y: auto;
  }

  .ivu-input {
    height: 35px;
    line-height: 35px;
  }

  .upload_styles {
    .ivu-upload.ivu-upload-drag {
      width: 120px;
      height: 120px;
    }

    .upload_icon_box {
      width: 120px;
      height: 120px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
    }

    .img_style {
      width: 120px;
      height: 120px;

      img {
        width: 100%;
        height: 100%;
        display: inline-block;
        object-fit: cover;
        vertical-align: middle;
      }
    }
  }

  .viewImgStyles {
    width: 120px;
    height: 120px;
    display: inline-block;
    object-fit: cover;
    vertical-align: middle;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #D7D7D7;
    box-sizing: border-box;
    cursor: pointer;
  }

  .labelText {
    font-size: 12px;
    position: relative;
    top: 1px;
  }
}
</style>
